export class DuplicatedCmlLabelError extends Error {
  public constructor(message: string = `Cannot create the same label for the same interactive isometric.`) {
    super(message);
    Object.setPrototypeOf(this, DuplicatedCmlLabelError.prototype);
  }
}
